import { render, staticRenderFns } from "./dynamicDate.vue?vue&type=template&id=fc952ad8&scoped=true"
import script from "./dynamicDate.vue?vue&type=script&lang=js"
export * from "./dynamicDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc952ad8",
  null
  
)

export default component.exports